import Moment from 'moment';
import CommonUtility from './CommonUtility';
const DATE_DDMMYYYY = "DD/MM/YYYY";

export default class DateUtils {
  static formatDate(val, frm) {
    let dt = new Date(val);
    if(!!dt && !isNaN(dt)) {
      let m = dt.getUTCMonth() + 1;
      let d = dt.getUTCDate();
      let y = dt.getUTCFullYear();
      // date format 02/22/2021
      m = m.toString().length > 1 ? m : "0" + m;
      d = d.toString().length > 1 ? d : "0" + d;
      switch (frm) {
        case DATE_DDMMYYYY:
          return `${d}/${m}/${y}`;
        default:
          let defaultDate = Moment(new Date(val)).format(DATE_DDMMYYYY);
          return defaultDate;
      }
    } return Moment(val, DATE_DDMMYYYY).format(DATE_DDMMYYYY);
  }

  static formatDateInMMDDYYYY(val) {
    if (!!val) {
      let dt = new Date(val);
      if(!dt ||! dt.getFullYear()) {
        dt = Moment(val, 'MM/DD/YYYY').toDate();
      }
      let m = dt.getMonth() + 1;
      let d = dt.getDate();
      let y = dt.getFullYear();
      // date format 02/22/2021
      m = m.toString().length > 1 ? m : "0" + m;
      d = d.toString().length > 1 ? d : "0" + d;
      return `${d}/${m}/${y}`;
    }
    else return "";
  }

  static formatDateInYYYYMMDD(val) {
    if (!!val) {
      let dt = new Date(val);
      let m = dt.getMonth() + 1;
      let d = dt.getDate();
      let y = dt.getFullYear();
      // date format 02/22/2021
      m = m.toString().length > 1 ? m : "0" + m;
      d = d.toString().length > 1 ? d : "0" + d;
      return `${y}-${m}-${d}`;
    }
    else return "";
  }

  static formatAMPM(dt) {
    // let time = new Date(dt).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: true });
    // return time;
       return Moment(dt).utc().format('hh:mm A');
  }

  static formatYYYYMMDDHHMMSS(date) {
    if (!date) date = new Date();
    return `${this.ConvertOnetoTwo(date.getDate())}${this.ConvertOnetoTwo(date.getMonth() + 1)}${date.getFullYear().toString()}${this.ConvertOnetoTwo(date.getHours())}${this.ConvertOnetoTwo(date.getMinutes())}${this.ConvertOnetoTwo(date.getSeconds())}`;
  }

  static ConvertOnetoTwo(n) {
    return n < 10 ? '0' + n : n;
  }

  static dateAscDescSort(property, order) {
    let sort_order = 1;
    if (order === "DESC") {
      sort_order = -1;
    }
    return function (a, b) {
      a = new Date(a[property]);
      b = new Date(b[property]);
      if (a < b) {
        return -1 * sort_order;
      } else if (a > b) {
        return 1 * sort_order;
      } else {
        return 0 * sort_order;
      }
    };
  }

  static isoFormateDate() {
    return new Date().toISOString();
  }

  static formatInIsoFormat(val, format = DATE_DDMMYYYY){
    return Moment(val, format).toISOString();
  }

  static formatforServer(dt) {
    let date = new Date(dt);
    let d = date.getDate();
    let m = date.getMonth() + 1;
    let y = date.getFullYear() + 1;
    let acd = `${d}/${m}/${y}`;
    return new Date(acd).toISOString();
  }
  static formatforDisplay(dt) {
    let d = new Date(dt.split("T")[0]);
    let acd = `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`;
    return acd;
  }

  static dateTodayYesterday(dt, format) {
    let displayTime;
    let datemes = CommonUtility.getUTCDate(new Date(dt));
    let CDateTime = CommonUtility.getUTCDate();
    let today = CDateTime;
    today.setHours(0, 0, 0, 0);
    let yesterday = new Date(CDateTime - 864e5);
    yesterday.setHours(0, 0, 0, 0);
    if (datemes >= today) {
      displayTime = `Today ${DateUtils.formatAMPM(dt)}`;
    } else if (datemes >= yesterday) {
      displayTime = `Yesterday ${DateUtils.formatAMPM(dt)}`;
    } else {
      displayTime = `${DateUtils.formatDate(dt, !!format ? format : DATE_DDMMYYYY)} ${DateUtils.formatAMPM(dt)}`;
    }
    return displayTime;
  }

  static dateAndTimeWithAmPm(dt, appName = "XBP") {
    return appName === "XBP" ?
      (DateUtils.formatDate(dt, DATE_DDMMYYYY) + " " + DateUtils.formatAMPM(dt)) :
       (DateUtils.formatDate(dt, DATE_DDMMYYYY) + " " + DateUtils.formatAMPM(dt));
  }

  static monthList() {
    return [...Array(12).keys()].map((i) => ({ label: ("0" + (i + 1)).slice(-2), value: ("0" + (i + 1)).slice(-2) }));
    // let months=[{ label: "01", value: "01" },{ label: "02", value: "02" },
    //             { label: "03", value: "03" },{ label: "04", value: "04" },
    //             { label: "05", value: "05" },{ label: "06", value: "06" },
    //             { label: "07", value: "07" },{ label: "08", value: "08" },
    //             { label: "09", value: "09" },{ label: "10", value: "10" },
    //             { label: "11", value: "11" },{ label: "12", value: "12" }
    //             ];
    //return months
  }
  static yearList() {
    let startYear = new Date().getFullYear();
    return [...Array(12).keys()].map((i) => ({ label: ("0" + (i + startYear)).slice(-4), value: ("0" + (i + startYear)).slice(-4) }));
    // let years=[{ label: "2021", value: "2021" },{ label: "2022", value: "2022" },
    //             { label: "2023", value: "2023" },{ label: "2024", value: "2024" },
    //             { label: "2025", value: "2025" },{ label: "2026", value: "2026" },
    //             { label: "2027", value: "2027" },{ label: "2028", value: "2028" },
    //             { label: "2029", value: "2029" },{ label: "2030", value: "2030" },
    //             { label: "2031", value: "2031" }
    //             ];
    //return years
  }

  static inBetweenDateChecker(curr, startDate = "", endDate = "") {
    // Parse the inputs into Moment.js objects
    const currDate = Moment(curr);
    const startDateObj = startDate ? Moment(startDate) : null;
    const endDateObj = endDate ? Moment(endDate) : null;

    if (!currDate.isValid()) return false;
    // Check if curr is within the date range
    if (startDateObj && endDateObj) {
      return currDate.isBetween(startDateObj, endDateObj, null, '[]'); // '[]' includes the start and end dates
    } else if (startDateObj) {
      return currDate.isSameOrAfter(startDateObj);
    } else if (endDateObj) {
      return currDate.isSameOrBefore(endDateObj);
    }
    // If no startDate or endDate is provided, return true
    return true;
  }

  static isOlderThanMaxLimit(val, max = 125){
    // Convert val to a Date object
    const date = new Date(val);

    // Get the current date
    const currentDate = new Date();

    // Calculate the maximum allowed date (max = 125 years ago from the current date)
    const maxAllowedDate = new Date();
    maxAllowedDate.setFullYear(currentDate.getFullYear() - max);

    // Compare val with the maximum allowed date
    return date < maxAllowedDate;
  }

  static getShortestDate(dateStrings = []){

    const dateObjects = dateStrings.map((dateString) => new Date(dateString));
    const shortestDate = new Date(Math.min(...dateObjects));

    // Format the result as MM/DD/YYYY
    const formattedDate =
      (shortestDate.getMonth() + 1).toString().padStart(2, '0') +
      '/' +
      shortestDate.getDate().toString().padStart(2, '0') +
      '/' +
      shortestDate.getFullYear();
    return formattedDate;
  }

  static getGreatestDate(dateStrings = []){
    const dateObjects = dateStrings.map((dateString) => new Date(dateString));
    const highestDate = new Date(Math.max(...dateObjects));

    // Format the result as MM/DD/YYYY
    const formattedDate =
      (highestDate.getMonth() + 1).toString().padStart(2, '0') +
      '/' +
      highestDate.getDate().toString().padStart(2, '0') +
      '/' +
      highestDate.getFullYear();
    return formattedDate;
  }

  static parseDDMMYYYYinNewDate(input) {
    // Convert the input to a string, except when it's undefined or null
    let dateString = input != null ? String(input) : input;

    // Check for undefined and return an invalid date
    if (dateString === undefined) return new Date(undefined); // This will create an invalid date

    if (!dateString) return new Date(); // or you can return a specific value like `new Date(0)` if preferred

    // Check if the input is an ISO 8601 format -> "2024-05-15T06:17:09Z"
    const iso8601Regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z$/;
    // Check if the input is a long date format -> Wed May 01 2024 18:33:35 GMT+0530 (India Standard Time)
    const longDateRegex = /^[A-Za-z]{3} [A-Za-z]{3} \d{2} \d{4} \d{2}:\d{2}:\d{2} GMT([+-]\d{4})? \([A-Za-z ]+\)$/;
    if (iso8601Regex.test(dateString) || longDateRegex.test(dateString)) return new Date(dateString);

   // Check if the input is in DD/MM/YYYY format with optional time
   const ddMMyyyyTimeRegex = /^(\d{2})\/(\d{2})\/(\d{4})( \d{2}:\d{2}:\d{2})?$/;
   const match = dateString.match(ddMMyyyyTimeRegex);
   if (match) {
       let day = parseInt(match[1], 10);
       let month = parseInt(match[2], 10) - 1; // Months are zero-indexed in JavaScript Date
       let year = parseInt(match[3], 10);

       if (match[4]) { // If there is a time component
           let timeParts = match[4].trim().split(':');
           let hours = parseInt(timeParts[0], 10);
           let minutes = parseInt(timeParts[1], 10);
           let seconds = parseInt(timeParts[2], 10);
           return new Date(year, month, day, hours, minutes, seconds);
       }

       // If no time component, create Date with year, month, day
       return new Date(year, month, day);
   }

    // Check if the input is a timestamp
    const timestampRegex = /^\d+$/;
    if (timestampRegex.test(dateString)) return new Date(parseInt(dateString, 10));
  }

  static dataTableDateFormatter (value) {
    let formattedDate = "";
    if (!!value && value.includes('/') && value.split(":") && value.split(":").length) {
      value.split(":").forEach(dat => {
        formattedDate = !!formattedDate && !!dat ? `${formattedDate}:${this.formatDateInMMDDYYYY(dat)}` : this.formatDateInMMDDYYYY(dat);
      });
      return formattedDate
    } else if (!!value) {
      return this.formatDateInMMDDYYYY(value);
    } else return value;
  };
}
